import Centered from "./Centered"
import Paper from "./Paper"
import PaperButton from "./PaperButton"
import Icon from "./Icon"
import {SvgIcon} from "./Icon"
import ScreenButton from "./ScreenButton"
import GameContent from "./GameContent"
import Video from "./Video"

export {
    Centered,
    Paper,
    PaperButton,
    Icon,
    SvgIcon,
    ScreenButton,
    GameContent,
    Video
}


// WEBPACK FOOTER //
// ./src/components/simple/index.js